// extracted by mini-css-extract-plugin
export default {"page-container":"common_page-container__8JMWC"};